import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import * as MegaMenusConstants from 'util/constants/megaMenuModuleGroups';

const SIZE_LARGE = 'large';

const mapNavConstantsToModuleGroup = (id, size) => {
  const {
    PRIMARY: { REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS, ALBUMS, ADVICE },
  } = NAV_DATA;

  switch (id) {
    case REGISTRY:
      return MegaMenusConstants.MEGA_MENU_REGISTRY;
    case WEBSITE:
      if (size === SIZE_LARGE) {
        return MegaMenusConstants.MEGA_MENU_WEBSITE_LARGE;
      }
      return MegaMenusConstants.MEGA_MENU_WEBSITE;
    case PAPER:
      return MegaMenusConstants.MEGA_MENU_PAPER;
    case ALBUMS:
      if (size === SIZE_LARGE) {
        return MegaMenusConstants.MEGA_MENU_ALBUMS_LARGE;
      }
      return MegaMenusConstants.MEGA_MENU_ALBUMS;
    case GUEST_LIST:
      return MegaMenusConstants.MEGA_MENU_GUEST_LIST;
    case WEDDING_BOUTIQUE:
      return MegaMenusConstants.MEGA_MENU_BOUTIQUE;
    case VENDORS:
      return MegaMenusConstants.MEGA_MENU_VENDORS;
    case ADVICE:
      return MegaMenusConstants.MEGA_MENU_ADVICE;
    default:
      return {};
  }
};

export default mapNavConstantsToModuleGroup;
